import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Form, Input, Button } from "antd";
import useStyles from "../../../style";
import { getT } from "../../../../../_utils/intl";
import SelectPhoneOrEmail from "./SelectPhoneOrEmail";
import { passwordPattern } from "./rules";
const ForgotPassword = ({ goLogin, verificationRequest, onForgotPassword }) => {
  const [genre, setGenre] = useState("phone");
  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { styles } = useStyles();
  const t = getT();
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await (onForgotPassword == null ? void 0 : onForgotPassword(values));
    } catch (error) {
      console.error("Reset password failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const validateConfirmPassword = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue("newPassword") === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(t("login.password.mismatch")));
    }
  });
  const handleGetVerificationCode = async () => {
    const { phoneNumber } = await form.validateFields(["phoneNumber"]);
    try {
      await (verificationRequest == null ? void 0 : verificationRequest(phoneNumber));
      setCountdown(60);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1e3);
    } catch (error) {
      console.error("Failed to send verification code:", error);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Form,
      {
        form,
        size: "large",
        onFinish: handleSubmit,
        children: [
          /* @__PURE__ */ jsx(
            Form.Item,
            {
              name: genre === "phone" ? "phoneNumber" : "email",
              rules: [
                {
                  required: true,
                  message: t("login.phoneNumber.required")
                }
                // verificationPattern,
              ],
              children: /* @__PURE__ */ jsx(SelectPhoneOrEmail, { changeGenre: setGenre })
            }
          ),
          /* @__PURE__ */ jsx(
            Form.Item,
            {
              name: "verifyCode",
              rules: [
                {
                  required: true,
                  message: t("login.verification.required")
                }
                // verificationPattern,
              ],
              children: /* @__PURE__ */ jsx(
                Input,
                {
                  placeholder: t("login.verification.placeholder"),
                  suffix: /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "link",
                      disabled: countdown > 0,
                      onClick: handleGetVerificationCode,
                      children: countdown > 0 ? `${countdown}s` : t("login.verification.get")
                    }
                  ),
                  maxLength: 6
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            Form.Item,
            {
              name: "newPassword",
              rules: [
                {
                  required: true,
                  message: t("login.password.required")
                },
                passwordPattern
              ],
              children: /* @__PURE__ */ jsx(Input.Password, { placeholder: t("login.password.new.placeholder") })
            }
          ),
          /* @__PURE__ */ jsx(
            Form.Item,
            {
              name: "confirm_password",
              dependencies: ["newPassword"],
              hasFeedback: true,
              rules: [
                {
                  required: true,
                  message: t("login.password.confirm.required")
                },
                passwordPattern,
                validateConfirmPassword
              ],
              children: /* @__PURE__ */ jsx(Input.Password, { placeholder: t("login.password.confirm.placeholder") })
            }
          ),
          /* @__PURE__ */ jsx(Form.Item, { children: /* @__PURE__ */ jsx(Button, { type: "primary", htmlType: "submit", block: true, loading, children: t("login.submit") }) })
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: styles.forgotPassword, children: /* @__PURE__ */ jsx(Button, { type: "link", onClick: goLogin, children: t("login.back") }) })
  ] });
};
var ForgotPassword_default = ForgotPassword;
export {
  ForgotPassword_default as default
};
